module.exports = __webpack_public_path__ + "static/img/placeholder-600-400.5c6d75cc.svg";